module.exports = __webpack_public_path__ + "static/img/17032414449895269326571.99a9f41.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/work/20231222/17032414449895269326571.jpeg
// module id = BWbG
// module chunks = 7